// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__3wlEh","itemList":"footer_itemList__1HI3N","item":"footer_item__3eqmr","link":"footer_link__2Q_mw"};